const storeNativeFacebookTokenInSessionStorage = (credential) => {
  window.sessionStorage.setItem('native_facebook_token', JSON.stringify(credential))
}

export default storeNativeFacebookTokenInSessionStorage
